import React from 'react'
import Layout from '../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TextileMartindaleAbrasionTester = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FTextileTesting%2Fimg%2F6.png?alt=media&token=00c4e3f0-0537-4916-b0f1-f9e95e613fef',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FTextileTesting%2Fimg%2F7.png?alt=media&token=00c4e3f0-0537-4916-b0f1-f9e95e613fef'
    ];

    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/textile">Textile</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Martindale Abrasion Tester</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Martindale Abrasion Tester</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    This machine is ideal for determining the abrasion resistance of paper, lining, socking and similar types of shoe materials, particularly those made of fabric. Conforms to Standards: ASTM D4966, BS 3424, DIN 53863, ISO 5470, GB/T 21196. Applicable Industry: Textile.
                                    <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Martindale Abrasion Tester"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
            <br /><br /><br /><br />
        </Layout>
    )
}

export default TextileMartindaleAbrasionTester
